import { parse, format, isValid } from 'date-fns';

type validDateType = {
  isValid: boolean;
  message?: string;
  formattedDate?: {
    'yyyy-MM-dd': string;
    'dd/MM/yyyy': string;
  };
};
export const isValidDate = (receivedDate: string): validDateType => {
  if (receivedDate) {
    let normalized = receivedDate.replace(new RegExp('/', 'g'), '');
    normalized = normalized.replace(new RegExp('-', 'g'), '');
    const formatValidDates = ['ddMMyyyy', 'yyyyMMdd'];

    let normalizedDate = null;
    const date = new Date();
    for (let i = 0; i < formatValidDates.length; i++) {
      normalizedDate = parse(normalized, formatValidDates[i], date);
      if (isValid(normalizedDate)) {
        return {
          isValid: true,
          formattedDate: {
            'yyyy-MM-dd': format(normalizedDate, 'yyyy-MM-dd'),
            'dd/MM/yyyy': format(normalizedDate, 'dd/MM/yyyy'),
          },
        };
      }
    }
  }
  return {
    isValid: false,
  };
};

type validMemberBirthdayTypes = {
  isValid: boolean;
  isValidDay: boolean;
  isValidMonth: boolean;
  isValidYear: boolean;
  minorLegal?: boolean;
  age?: number;
  formattedDate?: string;
  message?: string;
};

export const isValidBirthDate = (
  birthDate: string,
): validMemberBirthdayTypes => {
  const normalized = birthDate.replace(new RegExp('/', 'g'), '');

  const day = normalized.substring(0, 2);
  const dayNumber = Number(day);
  const month = normalized.substring(2, 4);
  const monthNumber = month ? Number(month) : 0;
  const year = normalized.substring(4, 8);
  const yearNumber = year ? Number(year) : 0;
  let isValidDay = false;
  let isValidMonth = false;
  let isValidYear = false;

  if (dayNumber <= 0 || dayNumber >= 32) {
    return {
      isValid: false,
      isValidDay,
      isValidMonth,
      isValidYear,
    };
  } else {
    isValidDay = true;
  }

  if (
    monthNumber === 0 ||
    monthNumber >= 13 ||
    (monthNumber === 2 && dayNumber >= 30) ||
    ([4, 6, 9, 11].includes(monthNumber) && dayNumber > 30)
  ) {
    return {
      isValid: false,
      isValidDay,
      isValidMonth,
      isValidYear,
    };
  } else {
    isValidMonth = true;
  }

  const date = new Date();
  const currentDay = date.getDate();
  const currentMonth = date.getMonth() + 1;
  const currentYear = date.getFullYear();

  // Regra Smiles
  if (yearNumber >= 1900 && yearNumber <= currentYear) {
    isValidYear = true;
    let age = currentYear - parseInt(year);
    if (
      currentMonth < parseInt(month) ||
      (currentMonth === parseInt(month) && currentDay < parseInt(day))
    ) {
      age--;
    }

    return {
      isValid: isValidDate(normalized).isValid,
      isValidDay,
      isValidMonth,
      isValidYear,
      minorLegal: age < 18,
      age,
      formattedDate: year + '-' + month + '-' + day,
    };
  }

  return {
    isValid: false,
    isValidDay,
    isValidMonth,
    isValidYear,
  };
};
